import { render, staticRenderFns } from "./BaseIcon.vue?vue&type=template&id=15f57517&scoped=true"
import script from "./BaseIcon.vue?vue&type=script&lang=ts"
export * from "./BaseIcon.vue?vue&type=script&lang=ts"
import style0 from "./BaseIcon.vue?vue&type=style&index=0&id=15f57517&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15f57517",
  null
  
)

export default component.exports